
        import 'SubHeader.36856c9.css-module'
        export default {"SubHeader":"SubHeader_SubHeader_36856c9","Edit":"Edit_SubHeader_36856c9"}
    